import { ALBUM_TYPE, ALBUM_SUBTYPE } from '../constants/albums';

const strings = {
  [ALBUM_TYPE.PRO]: {
    identityReference: 'member',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    consumerAlbum: 'album',
    consumerSelectAlbumsForOther: 'Add more people',
    consumerSelectAlbumsForCurrent: 'Join {identityName} to more albums',
    consumerDoneAddingFaces: 'I am done adding family members to albums',
    consumerSelectIdentityTitle: 'Select or add family members',
    albumDiscoveryEntryHeadline: `We've made viewing and purchasing your photos easier than ever before!`,
    albumDiscoveryEntryHeadlinePpd: `We've made viewing and purchasing your photos easier than ever before!`,
    albumDiscoveryEntry: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    albumDiscoveryEntryPf: `To get all your photos from the event, simply upload a selfie and Waldo's AI will find and deliver all the photos you're in!`,
    albumDiscoveryEntryPpd: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    subscriptionSuccessTitle: 'Welcome to Waldo at {name}',
    subscriptionSuccessMainText: 'Sit back and relax... as soon as your photos are found, you will receive a text or email notification!',
    subscriptionSuccessAppDownloadHeading: 'Want to share your photos? Download the Waldo app!',
    subscriptionSuccessSocialMessage: 'Make sure others know about Waldo!',
    subscriptionUpsellTitle: 'Go ahead, subscribe!',
    subscriptionUpsellText: 'ALL your {displayName} photos for {price}!',
    albumHeaderMembersLabel: 'Members',
    albumSidebarMembersHeaderLabel: 'Album Members',
    albumFolderSidebarMembersLabel: 'Gallery Members',
    prePaidAlbumsCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for you!',
    prePaidSingleAlbumCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for you!',
    prePaidAlbumsCheckoutMessageSubtitle: `Only one subscription per person please. You can invite family and friends to view your photo stream via the app!`,
    accountBrandingSettingsLogoTitle: 'Logo',
    accountBrandingSettingsLogoDesc: 'Brand all the web pages your users see on Waldo! Upload your logo here.',
    accountBrandingSettingsHeroTitle: 'Profile Page & Web Gallery Hero Image',
    accountBrandingSettingsHeroDesc: 'Customize your profile page and web gallery hero with your favorite photo. Upload it here.',
    accountBrandingSettingsHeroDescTip:
      'TIP: Want a custom collage? Email your 5 favorite photos and your name to {email} and we’ll create it for you.',
    identityPhotoUploadTitle: 'I’ll find all your photos!',
    identityNotNearbyLabel: 'Person not nearby?',
    identityOutdatedSelfieModalMessage: 'Waldo does his best work with a current selfie.',
    checkoutIdentitySelectionMessage: 'Select an identity below so I know who to find.',
    webGalleryUpsellModalTitle: 'Tired of scrolling? Let Waldo find the pics you want to see!',
    webGalleryUpsellModalText: 'Submit a selfie. Then, Waldo will find all your pics and text them to you.',
    albumFolderPurchaseCharityDefaultMessage: '*50% goes to charity. Thank you!',
    folderTreeViewNullStateMessage:
      'Once you start creating your galleries and albums on the right, I’ll start populating a list of all your photo collections here!',
    dashboardWelcomeMessage: 'Create a new album or gallery below to start powering your photos with facial and jersey recognition.',
    consumerAddNewIdentity: 'Find photos of a family member',
    consumerSelectOtherIdentity: 'Add more people',
    accessRequestFormParentMessage:
      'Hi, Waldo here! The {eventName} gallery is private and only directly accessible by users and/or customers of {accountName}. The mobile number you provided is either not in the {eventName}’s records or you have withheld consent for 3rd parties to access your information. Please complete the form below to give consent.',
    accessRequestFormEmailLabel: 'Your email address',
    accessRequestFormPhoneNumberLabel: 'Your phone number',
    accessRequestFormNameLabel: 'Your signature',
    accessRequestFormIdentityNameLabel: 'Enter name',
    accessRequestFormConsentText:
      'By submitting the following form I confirm I’m the parent or legal guardian of the following persons and consent to Waldo accessing their photos for purposes of delivering them to me.',
    selfieStationWaldoTitle: "Find your name below and smile big, then I'll find and deliver any photo you appear in.",
    selfieStationIdentityNotFound: 'We found no faces with this name. Please contact your photographer.',
    galleryHasNoMembers: 'There are no members currently joined to this gallery',
    albumHasNoMembers: 'There are no members currently joined to this album',
    selfieStationCreateRosterIdentityPhoneNumber: 'Mobile number',
    joinTypeSelectionHeader: 'Get all your pics from {name} delivered to your phone!',
    purchaseSubscriptionText: 'Photo Pass',

    joinTypeSelectionDiscountTitle: 'Buy all your pics now and save ${price}!',
    webGalleryCollageUpsellModalTitle: 'Save the Moment!',
    webGalleryCollageUpsellModalSubtitle: 'Create your custom 8x10 {collageName}!',
    accessRequestFormSubmitMessage: 'Yes, I would like Waldo to send me my identity’s {eventName} photos!',
    proLandingPageFeaturedTitle: 'Great News, {profileDisplayName} is now Waldo-fied!',
    proLandingPageFeaturedText:
      '{profileDisplayName} is excited to partner with Waldo Photos. Using facial recognition, Waldo delivers every photo that your family appears in straight to your phone.',
    accountSettingsDetailsLabel: 'Details',
    accountSettingsBrandingLabel: 'Branding',
    accountSettingsDisplayLabel: 'Display Settings',
    accountSettingsLandingPageLabel: 'Your custom profile page:',
    accountSettingsBusinessCardLabel: 'Your Business Card:',
    accountSettingsAddressesTitleLabel: 'Account Addresses',
    spotlightLabelTip:
      "Spot a great photo of a member you'd like to mark for a social post, slideshow or sending a birthday Waldogram? Spotlight it for easy dashboard access and exporting.",
    sellPhotosNullStateTitle: "Welcome to Waldo's Mobile Sales Platform!",
    sellPhotosNullStateSubtitle: 'Automated mobile proof delivery and sales',
    sellPhotosNullStateSubCopy: 'Sit back and relax as Waldo delivers everyone their proofs, processing orders and delivers prints!',
    albumCreatePhotoDelivery: 'Deliver matching photos to everyone you photograph or only those with Shutterbug subscriptions',
    waldoFindPhotosYouAreInTitle:
      'Enjoy the gallery but let Waldo do the \n hunting and pecking! All your \n photos sent via text alert when found.',
    inviteLabel: 'QR code & printables',
    inviteModalHeader: 'Invite to',
    shareModalFormHeader: 'Invite via email',

    // Null state:
    nullStateSubtitle: "Let's simplify your photo life.",
    nullStateCardLabel: 'Create an Event',

    // Serfie station
    selfieStationIdentityReference: 'member',
  },
  [ALBUM_TYPE.SHUTTERBUG]: {
    inviteLabel: 'Invite others',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    dashboardWelcomeMessage:
      "I make sharing easy. Just create an album or gallery (family of albums). Upload photos. Invite those you've photographed. I do the rest.",
    subscriptionSuccessMainText: 'Sit back and relax... as soon as your photos are found, you will receive a text or email notification!',
    subscriptionSuccessAppDownloadHeading: 'Want to share your photos? Download the Waldo app!',
    proLandingPageFeaturedText: 'Powered by AI, Waldo sends you every photo you appear in.',
    accountSettingsDetailsLabel: 'Profile',
    accountSettingsBrandingLabel: 'Cover Photo',
    accountSettingsDisplayLabel: 'Display Order',
    accountSettingsLandingPageLabel: 'All your listed events can be found at:',
    accountSettingsAddressesTitleLabel: 'My primary mailing address',
  },
  [ALBUM_SUBTYPE.CAMPS]: {
    identityReference: 'camper',
    firstNameLabel: "Camper's first name",
    lastNameLabel: "Camper's last name",
    consumerAlbum: 'session',
    organizationEntityReference: 'camp',
    consumerSelectAlbumsForOther: 'Add another camper',
    consumerSelectAlbumsForOtherLabel: 'Have more campers? {actionVerb} below to add them.',
    consumerSelectAlbumsForCurrent: 'Join {identityName} to more sessions',
    consumerDoneAddingFaces: 'I am done adding campers to sessions',
    albumDiscoveryEntryHeadline: `We've made viewing and purchasing your camper's photos easier than ever before!`,
    albumDiscoveryEntry: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    subscriptionSuccessSocialMessage: 'Make sure other parents know about Waldo!',
    albumHeaderMembersLabel: 'Campers',
    albumSidebarMembersHeaderLabel: 'Album Campers',
    albumFolderSidebarMembersLabel: 'Gallery Campers',
    prePaidAlbumsCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for your camper!',
    prePaidSingleAlbumCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for your camper!',
    prePaidAlbumsCheckoutMessageSubtitle: `Only one subscription per child please. You can invite family and friends to view your camper’s photo stream via the app!`,
    accountBrandingSettingsLogoTitle: 'Your Camp Logo',
    accountBrandingSettingsLogoDesc: 'Brand all the web pages your camp families see on Waldo! Upload your logo here.',
    accountBrandingSettingsHeroTitle: 'Profile Page & Web Gallery Hero Image',
    accountBrandingSettingsHeroDesc: 'Customize your profile page and web gallery hero with your favorite camp photo. Upload it here.',
    accountBrandingSettingsHeroDescTip:
      'TIP: Want a custom collage? Email your 5 favorite photos and your camp name to {email} and we’ll create it for you.',
    identityMetadataHeader: 'Cabin Name',
    identityPhotoUploadTitle: 'I’ll find all your camper’s photos!',
    identityNotNearbyLabel: 'Camper not nearby?',
    identityOutdatedSelfieModalMessage: 'Waldo does his best work with a current selfie.',
    checkoutIdentitySelectionMessage: 'Select the camper whose photos you’d like me to find or add a new one at {entityName}.',
    webGalleryUpsellModalTitle: "Tired of scrolling? Let Waldo find your camper's photos!",
    webGalleryUpsellModalText: "Submit a photo of your camper. Then, Waldo will find all your camper's pics and text them to you.",
    albumFolderPurchaseCharityDefaultMessage: '*50% goes to camper scholarships',
    consumerSelectIdentityTitle: 'Please add the name and a recent, well-lit headshot of your camper!',
    consumerAddNewIdentity: 'Find photos of a camper',
    consumerSelectOtherIdentity: 'Add another camper',
    selfieStationWaldoTitle: "Find your name below and smile big, then I'll find and deliver any photo you appear in",
    selfieStationIdentityNotFound: 'We found no campers with this name. Please contact your camp administrator.',
    accessRequestFormParentMessage:
      'Hi, Waldo here! The {eventName} gallery is private and only accessible by the parents and guardians of campers at {accountName}. The mobile number you provided is either not in the camp’s records or you have withheld consent for 3rd parties to access your information. Please complete the form below to give consent. Once enrolled, you will be able to share the photos via the app with your camper and other family members.',
    accessRequestFormEmailLabel: 'Email of Parent or Guardian',
    accessRequestFormPhoneNumberLabel: 'Mobile Number of Parent or Guardian',
    accessRequestFormNameLabel: 'Name of Parent or Legal Guardian (Your Full Name)',
    accessRequestFormIdentityNameLabel: 'Camper’s name',
    accessRequestFormConsentText:
      'By submitting the following form I confirm I’m the parent or legal guardian of the following camper(s) and consent to Waldo’s accessing their camp photos for purposes of delivering them to me.',
    galleryHasNoMembers: 'There are no campers currently joined to this gallery',
    albumHasNoMembers: 'There are no campers currently joined to this album',
    selfieStationCreateRosterIdentityPhoneNumber: 'Mobile number',
    subscriptionSuccessMainText: 'Sit back and relax... as soon as your photos are found, you will receive a text or email notification!',
    subscriptionSuccessTitle: 'Welcome to Waldo at {name}',
    webGalleryCollageUpsellModalTitle: 'Surprise your Camper!',
    webGalleryCollageUpsellModalSubtitle: 'Create your custom 8x10 CamperCollage!',
    accessRequestFormSubmitMessage: 'Yes, I would like Waldo to send me my camper’s {eventName} photos!',
    proLandingPageFeaturedText:
      '{profileDisplayName} is excited to partner with Waldo Photos. Using facial recognition, Waldo delivers every photo that your camper appears in straight to your phone.',
    spotlightLabelTip:
      "Spot a great photo of a camper you'd like to mark for a slideshow, yearbook or birthday Waldogram? Spotlight it  for easy dashboard access and exporting.",
    sellPhotosNullStateTitle: 'Hi, welcome to Waldo-fying your picture sales!',
    sellPhotosNullStateSubtitle: 'The easiest way to turn your photos into fundraising',
    sellPhotosNullStateSubCopy: 'Then, sit back, relax, and Waldo will deposit your funds raised!',
    albumCreatePhotoDelivery: 'Deliver matching photos to everyone you photograph',
    waldoFindPhotosYouAreInTitle:
      "Enjoy the gallery but let Waldo do the \n hunting and pecking! All your camper's \n photos sent via text alert when found.",
    inviteLabel: 'QR code & printables',
    selfieStationIdentityReference: 'camper',
    columnMatcherClaimedOnly: 'Automatically send proofs to all campers added',
  },
  [ALBUM_SUBTYPE.SCHOOLS]: {
    identityReference: 'student',
    firstNameLabel: "Student's first name",
    lastNameLabel: "Student's last name",
    organizationEntityReference: 'school',
    consumerAlbum: 'album',
    consumerAddNewIdentity: 'Find photos of a student',
    consumerSelectOtherIdentity: 'Add more students',
    consumerSelectIdentityTitle: 'Please add the name and a recent, well-lit headshot of your student!',
    consumerSelectAlbumsForOther: 'Add more students',
    consumerSelectAlbumsForOtherLabel: 'Have more students? {actionVerb} below to add them.',
    consumerSelectAlbumsForCurrent: 'Join {identityName} to more albums',
    consumerDoneAddingFaces: 'I am done adding students to albums',
    albumDiscoveryEntryHeadline: `We've made viewing your student's photos easier than ever before!`,
    albumDiscoveryEntryHeadlinePaid: `We've made viewing and purchasing your student's photos easier than ever before!`,
    albumDiscoveryEntry: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    subscriptionSuccessSocialMessage: 'Make sure other parents know about Waldo!',
    albumHeaderMembersLabel: 'Students',
    albumSidebarMembersHeaderLabel: 'Album Students',
    albumFolderSidebarMembersLabel: 'Gallery Students',
    prePaidAlbumsCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for you!',
    prePaidSingleAlbumCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for your family!',
    prePaidAlbumsCheckoutMessageSubtitle: `Only one subscription per student please. You can invite family and friends to view your student’s photo stream via the app!`,
    accountBrandingSettingsLogoTitle: 'Your School Logo',
    accountBrandingSettingsLogoDesc: 'Brand all the web pages your school families see on Waldo! Upload your logo here.',
    accountBrandingSettingsHeroTitle: 'Profile Page & Web Gallery Hero Image',
    accountBrandingSettingsHeroDesc: 'Customize your profile page and web gallery hero with your favorite school photo. Upload it here.',
    accountBrandingSettingsHeroDescTip:
      'TIP: Want a custom collage? Email your 5 favorite photos and your school name to {email} and we’ll create it for you.',
    identityMetadataHeader: 'Grade',
    identityPhotoUploadTitle: 'I’ll find all your student’s photos!',
    identityOutdatedSelfieModalMessage: 'Waldo does his best work with a current selfie.',
    identityNotNearbyLabel: 'Student not nearby?',
    checkoutIdentitySelectionMessage: 'Select the student whose photos you’d like me to find or add a new one at {entityName}.',
    webGalleryUpsellModalTitle: 'Tired of scrolling? Let Waldo find your student’s photos!',
    webGalleryUpsellModalText: 'Submit a photo of your student. Then, Waldo will find all your student’s pics and text them to you.',
    albumFolderPurchaseCharityDefaultMessage: '*50% goes to student scholarships',
    dashboardWelcomeMessage: 'Create a gallery below to start powering your photos with facial and jersey recognition.',
    folderTreeViewNullStateMessage:
      'Once you start creating your galleries on the right, I’ll start populating a list of all your photo collections here!',
    accessRequestFormParentMessage:
      'Hi there! {eventName} is a private gallery and the mobile number or email you provided has not consented to share you information with Waldo. If you’re a parent or legal guardian of a {accountName} student, and would like to modify your information consent with {accountName} for purposes of using the Waldo service, please complete the form below. If you’re a student, please ask your parent or legal guardian to enroll in Waldo and they can share your photo stream with you via the app!',
    accessRequestFormEmailLabel: 'Email of Parent or Guardian',
    accessRequestFormPhoneNumberLabel: 'Mobile Number of Parent or Guardian',
    accessRequestFormNameLabel: 'Name of Parent or Legal Guardian (Your Full Name)',
    accessRequestFormIdentityNameLabel: 'Name of Your Student(s)',
    accessRequestFormConsentText:
      'By submitting the following form I confirm I’m the parent or legal guardian of the following student(s) and consent to Waldo’s accessing their school photos for purposes of delivering them to me.',
    selfieStationWaldoTitle: "Find your name below and smile big, then I'll find and deliver any photo you appear in",
    selfieStationIdentityNotFound: 'We found no students with this name. Please contact your school administrator.',
    galleryHasNoMembers: 'There are no students currently joined to this gallery',
    albumHasNoMembers: 'There are no students currently joined to this album',
    selfieStationCreateRosterIdentityPhoneNumber: 'Mobile number',
    webGalleryCollageUpsellModalTitle: 'Surprise your Student',
    webGalleryCollageUpsellModalSubtitle: 'Create your custom 8x10 {collageName}!',
    accessRequestFormSubmitMessage: 'Yes, I would like Waldo to send me my student’s {eventName} photos!',
    proLandingPageFeaturedText:
      '{profileDisplayName} is excited to partner with Waldo Photos. Using facial recognition, Waldo delivers every photo that your student appears in straight to your phone.',
    spotlightLabelTip:
      "Spot a great photo of a student you'd like to mark for a slideshow, yearbook or birthday Waldogram? Spotlight it  for easy dashboard access and exporting.",
    sellPhotosNullStateTitle: 'Hi, welcome to Waldo-fying your picture sales!',
    sellPhotosNullStateSubtitle: 'The easiest way to turn your photos into fundraising',
    sellPhotosNullStateSubCopy: 'Then, sit back, relax, and Waldo will deposit your funds raised!',
    waldoFindPhotosYouAreInTitle:
      "Enjoy the gallery but let Waldo do the \n hunting and pecking! All your student's \n photos sent via text alert when found.",
    inviteLabel: 'QR code & printables',

    nullStateSubtitle: "Let's simplify and secure your school photos!",
    nullStateCardLabel: 'Create school gallery',
    selfieStationIdentityReference: 'student',
    columnMatcherClaimedOnly: 'Automatically send proofs to all students added',
    addHeadshotPrompt: 'Please add the name and a recent, well-lit headshot of your student!',
  },
  [ALBUM_SUBTYPE.YOUTH_SPORTS]: {
    identityReference: 'athlete',
    albumDiscoveryEntryHeadline: `We've made viewing and purchasing your photos easier than ever before!`,
    albumDiscoveryEntry: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    subscriptionUpsellTitle: 'Get your Action Pass!',
    subscriptionUpsellText: 'ALL your {displayName} action shots for {price}!',
    identityMetadataHeader: 'Jersey Number',
    consumerAddNewIdentity: 'Find photos of an athlete',
    consumerSelectOtherIdentity: 'Add more athletes',
    accessRequestFormParentMessage:
      'Hi, Waldo here! The {eventName} gallery is private and only accessible by the parents and guardians of athletes competing or performing in it. The mobile number you provided is either not in {eventName}’s records or you have withheld consent for 3rd parties to access your information. Please complete the form below to give consent. Once enrolled, you will be able to share the photos via the app with your athlete and other family members.',
    accessRequestFormEmailLabel: 'Email of Parent or Guardian',
    accessRequestFormPhoneNumberLabel: 'Mobile Number of Parent or Guardian',
    accessRequestFormNameLabel: 'Name of Parent or Legal Guardian (Your Full Name)',
    accessRequestFormIdentityNameLabel: 'Athlete’s name...',
    accessRequestFormConsentText:
      'By submitting the following form I confirm I’m the parent or legal guardian of the following athlete(s) and consent to Waldo’s accessing their performance photos for purposes of delivering them to me.',
    joinTypeSelectionHeader: 'Get all your professional action shots from {name} delivered to your phone!',
    purchaseSubscriptionText: 'Action Pass',

    joinTypeSelectionDiscountTitle: 'Buy your Action Pass now and save ${price}!',
    webGalleryCollageUpsellModalTitle: 'Surprise your Athlete!',
    webGalleryCollageUpsellModalSubtitle: 'Create your custom 8x10 {collageName}!',
    accessRequestFormSubmitMessage: 'Yes, I would like Waldo to send me my athlete’s {eventName} photos!',
    spotlightLabelTip:
      "Spot a great photo of an athlete you'd like to mark for a slideshow, social post or re-enrollment Waldogram? Spotlight it for easy dashboard access and exporting.",
    sellPhotosNullStateTitle: 'Hi, welcome to Waldo-fying your picture sales!',
    sellPhotosNullStateSubtitle: 'The easiest way to turn your photos into fundraising',
    sellPhotosNullStateSubCopy: 'Then, sit back, relax, and Waldo will deposit your funds raised!',
    selfieStationIdentityReference: 'athlete',
    columnMatcherClaimedOnly: 'Automatically send proofs to all athletes added',
    addHeadshotPrompt: 'Please add the name and a recent, well-lit headshot of your athlete!',
  },
  [ALBUM_TYPE.EVENT]: {
    inviteLabel: 'Invite others',
    inviteModalHeader: 'Invite to',
    shareModalFormHeader: 'Invite via email',
  },
  [ALBUM_SUBTYPE.EVENTS]: {
    folderTreeViewNullStateMessage: 'Once you have galleries or albums I’ll start populating a list of all your photo collections here!',
    dashboardWelcomeMessage: 'Request a new album below to start powering your photos with facial and jersey recognition.',
  },
  [ALBUM_SUBTYPE.WEDDINGS]: {
    subscriptionSuccessTitle: 'Welcome to Waldo at {name}',
    subscriptionSuccessMainText: 'Sit back and relax... as soon as your photos are found, you will receive a text or email notification!',
    accessRequestFormParentMessage: '',
    inviteLabel: 'Invite others',
    inviteModalHeader: 'Invite guests to',
    shareModalFormHeader: 'Invite through email',
    albumHeaderMembersLabel: 'Guests',
    albumSidebarMembersHeaderLabel: 'Album Guests',
    albumFolderSidebarMembersLabel: 'Gallery Guests',
    weddingEventLabel: 'Wedding',
  },
  [ALBUM_SUBTYPE.GREEK]: {
    identityReference: 'member',
    consumerAlbum: 'album',
    consumerSelectAlbumsForOther: 'Add more people',
    consumerSelectAlbumsForCurrent: 'Join {identityName} to more albums',
    consumerDoneAddingFaces: 'I am done adding members to albums',
    consumerSelectIdentityTitle: 'Please add the name and a recent, well-lit headshot of your member!',
    proLandingPageFeaturedText: 'Powered by AI, Waldo sends you every photo you appear in.',
    sellPhotosNullStateTitle: 'Hi, welcome to Waldo-fying your picture sales!',
    sellPhotosNullStateSubtitle: 'The easiest way to turn your photos into fundraising',
    sellPhotosNullStateSubCopy: 'Then, sit back, relax, and Waldo will deposit your funds raised!',
    selfieStationIdentityReference: 'member',
  },
  [ALBUM_SUBTYPE.SPORTS]: {
    identityReference: 'athlete',
    albumDiscoveryEntryHeadline: `We've made viewing and purchasing your photos easier than ever before!`,
    albumDiscoveryEntry: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    subscriptionUpsellTitle: 'Get your Action Pass!',
    subscriptionUpsellText: 'ALL your {displayName} action shots for {price}!',
    identityMetadataHeader: 'Jersey Number',
    consumerAddNewIdentity: 'Find photos of an athlete',
    consumerSelectOtherIdentity: 'Add more athletes',
    accessRequestFormParentMessage:
      'Hi, Waldo here! The {eventName} gallery is private and only accessible by the parents and guardians of athletes competing or performing in it. The mobile number you provided is either not in {eventName}’s records or you have withheld consent for 3rd parties to access your information. Please complete the form below to give consent. Once enrolled, you will be able to share the photos via the app with your athlete and other family members.',
    accessRequestFormEmailLabel: 'Email of Parent or Guardian',
    accessRequestFormPhoneNumberLabel: 'Mobile Number of Parent or Guardian',
    accessRequestFormNameLabel: 'Name of Parent or Legal Guardian (Your Full Name)',
    accessRequestFormIdentityNameLabel: 'Athlete’s name...',
    accessRequestFormConsentText:
      'By submitting the following form I confirm I’m the parent or legal guardian of the following athlete(s) and consent to Waldo’s accessing their performance photos for purposes of delivering them to me.',
    joinTypeSelectionHeader: 'Get all your professional action shots from {name} delivered to your phone!',
    purchaseSubscriptionText: 'Action Pass',

    joinTypeSelectionDiscountTitle: 'Buy your Action Pass now and save ${price}!',
    webGalleryCollageUpsellModalTitle: 'Surprise your Athlete!',
    webGalleryCollageUpsellModalSubtitle: 'Create your custom 8x10 {collageName}!',
    accessRequestFormSubmitMessage: 'Yes, I would like Waldo to send me my athlete’s {eventName} photos!',
    spotlightLabelTip:
      "Spot a great photo of an athlete you'd like to mark for a slideshow, social post or re-enrollment Waldogram? Spotlight it for easy dashboard access and exporting.",
    proLandingPageFeaturedTitle: 'Great News, {profileDisplayName} is now Waldo-fied!',
    proLandingPageFeaturedText:
      "Finally, everyone's photos, easily shared, all in one gallery and powered by Waldo's facial recognition and automated mobile delivery! Join the gallery for your event and never miss a moment.",
    waldoFindPhotosYouAreInTitle:
      "Enjoy the gallery but let Waldo do the \\n hunting and pecking! All your athlete's \\n photos sent via text alert when found.",
    selfieStationIdentityReference: 'athlete',
  },
  [ALBUM_SUBTYPE.CHURCH]: {
    identityReference: 'member',
    organizationEntityReference: 'church',
    consumerAlbum: 'album',
    consumerAddNewIdentity: 'Find photos of a member',
    consumerSelectOtherIdentity: 'Add more people',
    consumerSelectIdentityTitle: 'Please add the name and a recent, well-lit headshot of your member!',
    consumerSelectAlbumsForOther: 'Add more people',
    consumerSelectAlbumsForOtherLabel: 'Have more members? {actionVerb} below to add them.',
    consumerSelectAlbumsForCurrent: 'Join {identityName} to more albums',
    consumerDoneAddingFaces: 'I am done adding members to albums',
    albumDiscoveryEntryHeadline: `We've made viewing and purchasing your photos easier than ever before!`,
    albumDiscoveryEntry: `Just upload a headshot of the person we photographed and Waldo's AI will find and deliver all the photos they're in!`,
    subscriptionSuccessSocialMessage: 'Make sure other parents know about Waldo!',
    albumHeaderMembersLabel: 'Members',
    albumSidebarMembersHeaderLabel: 'Album Members',
    albumFolderSidebarMembersLabel: 'Gallery Members',
    prePaidAlbumsCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for you!',
    prePaidSingleAlbumCheckoutMessage: 'Great news! {name} has pre-paid for your automated photo delivery for your family!',
    prePaidAlbumsCheckoutMessageSubtitle: `Only one subscription per member please. You can invite family and friends to view your photo stream via the app!`,
    accountBrandingSettingsLogoTitle: 'Your Church Logo',
    accountBrandingSettingsLogoDesc: 'Brand all the web pages your church families see on Waldo! Upload your logo here.',
    accountBrandingSettingsHeroTitle: 'Profile Page & Web Gallery Hero Image',
    accountBrandingSettingsHeroDesc: 'Customize your profile page and web gallery hero with your favorite church photo. Upload it here.',
    identityPhotoUploadTitle: 'I’ll find all your member’s photos!',
    identityOutdatedSelfieModalMessage: 'Waldo does his best work with a current selfie.',
    identityNotNearbyLabel: 'Family Member not nearby?',
    checkoutIdentitySelectionMessage: 'Select the family member whose photos you’d like me to find or add a new one at {entityName}.',
    webGalleryUpsellModalTitle: 'Tired of scrolling? Let Waldo find your photos!',
    webGalleryUpsellModalText: 'Submit a photo of your family member. Then, Waldo will find all your pics and text them to you.',
    albumFolderPurchaseCharityDefaultMessage: '*50% goes to member scholarships',
    dashboardWelcomeMessage: 'Create a gallery below to start powering your photos with facial and jersey recognition.',
    folderTreeViewNullStateMessage:
      'Once you start creating your galleries on the right, I’ll start populating a list of all your photo collections here!',
    accessRequestFormParentMessage:
      'Hi there! {eventName} is a private gallery and the mobile number or email you provided has not consented to share you information with Waldo. If you’re a parent or legal guardian of a {accountName} member, and would like to modify your information consent with {accountName} for purposes of using the Waldo service, please complete the form below. If you’re a member, please ask your parent or legal guardian to enroll in Waldo and they can share your photo stream with you via the app!',
    accessRequestFormEmailLabel: 'Email of Parent or Guardian',
    accessRequestFormPhoneNumberLabel: 'Mobile Number of Parent or Guardian',
    accessRequestFormNameLabel: 'Name of Parent or Legal Guardian (Your Full Name)',
    accessRequestFormIdentityNameLabel: 'Name of Your Member(s)',
    accessRequestFormConsentText:
      'By submitting the following form I confirm I’m the parent or legal guardian of the following person(s) and consent to Waldo’s accessing their church photos for purposes of delivering them to me.',
    selfieStationWaldoTitle: "Find your name below and smile big, then I'll find and deliver any photo you appear in",
    selfieStationIdentityNotFound: 'We found no members with this name. Please contact your church administrator.',
    galleryHasNoMembers: 'There are no members currently joined to this gallery',
    albumHasNoMembers: 'There are no members currently joined to this album',
    selfieStationCreateRosterIdentityPhoneNumber: 'Mobile number',
    webGalleryCollageUpsellModalTitle: 'Surprise your Family & Friends!',
    webGalleryCollageUpsellModalSubtitle: 'Create your custom 8x10 {collageName}!',
    accessRequestFormSubmitMessage: 'Yes, I would like Waldo to send me my {eventName} photos!',
    proLandingPageFeaturedText:
      '{profileDisplayName} is excited to partner with Waldo Photos. Using facial recognition, Waldo delivers every photo that you or your family members appear in straight to your phone.',
    sellPhotosNullStateTitle: 'Hi, welcome to Waldo-fying your picture sales!',
    sellPhotosNullStateSubtitle: 'The easiest way to turn your photos into fundraising',
    sellPhotosNullStateSubCopy: 'Then, sit back, relax, and Waldo will deposit your funds raised!',
    selfieStationIdentityReference: 'member',
  },
};

export default strings;
